import React from 'react';

const TimeForwardIcon = ({ width = 26, height = 26, color = '#0F7F85' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 26 26" fill="none">
      <g clipPath="url(#clip0_2897_5077)">
        <path
          d="M26 11.375V4.875L24.2125 6.6625C22.1 2.6 17.875 0 13 0C5.85 0 0 5.85 0 13C0 20.15 5.85 26 13 26C16.9 26 20.475 24.2125 22.75 21.45L20.3125 19.3375C18.525 21.45 15.925 22.75 13 22.75C7.6375 22.75 3.25 18.3625 3.25 13C3.25 7.6375 7.6375 3.25 13 3.25C16.9 3.25 20.3125 5.6875 21.9375 8.9375L19.5 11.375H26Z"
          fill={color}
        />
        <path
          d="M16.3975 9.19824C16.8391 8.86658 17.4662 8.95585 17.7979 9.39746C18.4669 10.2884 18.8748 11.3484 18.9756 12.458C19.0763 13.5675 18.8657 14.6829 18.3682 15.6797C17.8705 16.6766 17.1047 17.5152 16.1572 18.1016C15.2098 18.6879 14.1181 18.9993 13.0039 19C11.8896 19.0007 10.7969 18.6907 9.84863 18.1055C8.90057 17.5203 8.13365 16.6827 7.63477 15.6865C7.13595 14.6903 6.92407 13.5745 7.02344 12.4648C7.12286 11.3552 7.53029 10.295 8.19824 9.40332C8.52935 8.96159 9.15573 8.87127 9.59766 9.20215C10.0397 9.53323 10.1299 10.1605 9.79883 10.6025C9.3535 11.1971 9.08187 11.9037 9.01562 12.6436C8.94939 13.3834 9.09121 14.1269 9.42383 14.791C9.75645 15.4552 10.2673 16.0142 10.8994 16.4043C11.5315 16.7943 12.2602 17.0005 13.0029 17C13.7456 16.9995 14.4739 16.7922 15.1055 16.4014C15.7369 16.0105 16.2474 15.4515 16.5791 14.7871C16.9109 14.1226 17.0506 13.3784 16.9834 12.6387C16.9162 11.8989 16.6443 11.1926 16.1982 10.5986C15.8666 10.157 15.9559 9.52991 16.3975 9.19824ZM12 12V8C12 7.44776 12.4478 7.00007 13 7C13.5523 7 14 7.44772 14 8V12C13.9999 12.5522 13.5522 13 13 13C12.4478 12.9999 12.0001 12.5522 12 12Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_2897_5077">
          <rect width="26" height="26" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TimeForwardIcon;
